import { render } from "./CandidatoListagem.vue?vue&type=template&id=5d679b6a&ts=true"
import script from "./CandidatoListagem.vue?vue&type=script&lang=ts"
export * from "./CandidatoListagem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__